import React from 'react';
import { useSelector } from 'react-redux';
import { Block } from '@klp/design';
import { Main } from '@klp/layout/Main';
import { FrontpageForBygg } from './FrontpageForBygg';
import { FrontpageGeneral } from './FrontpageGeneral';
import { contextSelectors } from '@klp/contextSelector/index';

export const Frontpage = () => {
    const { selectedContext } = useSelector(contextSelectors);

    return (
        <Main>
            <Block>
                {selectedContext && <FrontpageForBygg />}
                {!selectedContext && <FrontpageGeneral />}
            </Block>
        </Main>
    );
};
